export const AssemblyNavigationStyle = {
  flexDirection: 'row',
  gap: 0.5,
  alignItems: 'center',
};
